// import * as Sentry from '@sentry/nextjs';

// Sentry.init({
//   enabled: !window.__ENV__?.SENTRY_DISABLED,
//   environment: window.__ENV__?.APP_ENV || 'unknown',
//   dsn: '#',
//   integrations: [
//     Sentry.browserTracingIntegration(),
//     Sentry.replayIntegration()
//   ],
//   sendDefaultPii: true,
//   _experiments: { enableLogs: true },
//   tracesSampleRate: 1.0,
//   replaysSessionSampleRate: 0.1,
//   replaysOnErrorSampleRate: 1.0
// });

// export const onRouterTransitionStart = Sentry.captureRouterTransitionStart;
